(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-draw-additions/assets/javascripts/draws.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-draw-additions/assets/javascripts/draws.js');
"use strict";

const _React = React,
  useCallback = _React.useCallback;
const BaseWeek = svs.components.tipsen.couponAdditionsComponents.Weeks;
const Draws = () => {
  const presentableWeek = useCallback(numberOfWeeks => "".concat(numberOfWeeks, " omg\xE5ng").concat(numberOfWeeks > 1 ? 'ar' : ''), []);
  return React.createElement(BaseWeek, {
    description: "V\xE4lj hur m\xE5nga omg\xE5ngar du vill spela din rad.",
    icon: "calendar-week",
    legend: "Antal omg\xE5ngar spelet ska p\xE5g\xE5",
    presentableWeek: presentableWeek,
    title: "Spela fler omg\xE5ngar"
  });
};
setGlobal('svs.components.tipsen.couponDrawAddition.Draws', Draws);

 })(window);